import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
  weatherData: [],
  selectedWeatherData: null,
  loading: false,
  isError: false,
  errorMessage: "",
  totalRecords: 0,
  currentPage: 1,
  totalPages: 1,
  filters: {
    search: "",
    category: "all",
    status: "all", // all, active, inactive, draft
    dateRange: null,
    location: "",
  },
  sortBy: "createdAt",
  sortOrder: "desc",
  categories: [],
  locations: [],
  bulkActions: {
    selectedItems: [],
    isSelectAll: false,
  },
  uploadProgress: 0,
  isUploading: false,
};

const adminContentManagementSlice = createSlice({
  name: "ADMIN_CONTENT_MANAGEMENT",
  initialState: initial_state,
  reducers: {
    updateAdminContentManagement: (state, { payload }) => {
      return { ...state, ...payload };
    },
    setWeatherData: (state, { payload }) => {
      state.weatherData = payload.data || payload;
      state.totalRecords = payload.totalRecords || payload.length;
      state.totalPages = payload.totalPages || 1;
    },
    setSelectedWeatherData: (state, { payload }) => {
      state.selectedWeatherData = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.isError = true;
      state.errorMessage = payload;
    },
    clearError: (state) => {
      state.isError = false;
      state.errorMessage = "";
    },
    setFilters: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
      state.currentPage = 1;
    },
    setSorting: (state, { payload }) => {
      state.sortBy = payload.sortBy;
      state.sortOrder = payload.sortOrder;
    },
    setPagination: (state, { payload }) => {
      state.currentPage = payload.page;
    },
    setCategories: (state, { payload }) => {
      state.categories = payload;
    },
    setLocations: (state, { payload }) => {
      state.locations = payload;
    },
    addWeatherData: (state, { payload }) => {
      state.weatherData.unshift(payload);
      state.totalRecords += 1;
    },
    updateWeatherData: (state, { payload }) => {
      const index = state.weatherData.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.weatherData[index] = { ...state.weatherData[index], ...payload };
      }
      if (state.selectedWeatherData && state.selectedWeatherData.id === payload.id) {
        state.selectedWeatherData = { ...state.selectedWeatherData, ...payload };
      }
    },
    deleteWeatherData: (state, { payload }) => {
      state.weatherData = state.weatherData.filter(item => item.id !== payload);
      state.totalRecords -= 1;
      if (state.selectedWeatherData && state.selectedWeatherData.id === payload) {
        state.selectedWeatherData = null;
      }
    },
    // Bulk actions
    toggleItemSelection: (state, { payload }) => {
      const itemId = payload;
      const isSelected = state.bulkActions.selectedItems.includes(itemId);
      if (isSelected) {
        state.bulkActions.selectedItems = state.bulkActions.selectedItems.filter(id => id !== itemId);
      } else {
        state.bulkActions.selectedItems.push(itemId);
      }
    },
    selectAllItems: (state) => {
      state.bulkActions.isSelectAll = true;
      state.bulkActions.selectedItems = state.weatherData.map(item => item.id);
    },
    clearItemSelection: (state) => {
      state.bulkActions.isSelectAll = false;
      state.bulkActions.selectedItems = [];
    },
    bulkUpdateItems: (state, { payload }) => {
      const { itemIds, updates } = payload;
      state.weatherData = state.weatherData.map(item => 
        itemIds.includes(item.id) ? { ...item, ...updates } : item
      );
      state.bulkActions.selectedItems = [];
      state.bulkActions.isSelectAll = false;
    },
    bulkDeleteItems: (state, { payload }) => {
      const itemIds = payload;
      state.weatherData = state.weatherData.filter(item => !itemIds.includes(item.id));
      state.totalRecords -= itemIds.length;
      state.bulkActions.selectedItems = [];
      state.bulkActions.isSelectAll = false;
    },
    setUploadProgress: (state, { payload }) => {
      state.uploadProgress = payload;
    },
    setUploading: (state, { payload }) => {
      state.isUploading = payload;
    },
  },
});

export const {
  updateAdminContentManagement,
  setWeatherData,
  setSelectedWeatherData,
  setLoading,
  setError,
  clearError,
  setFilters,
  setSorting,
  setPagination,
  setCategories,
  setLocations,
  addWeatherData,
  updateWeatherData,
  deleteWeatherData,
  toggleItemSelection,
  selectAllItems,
  clearItemSelection,
  bulkUpdateItems,
  bulkDeleteItems,
  setUploadProgress,
  setUploading,
} = adminContentManagementSlice.actions;
export default adminContentManagementSlice.reducer;
